import axios from "./axios/rawAxios"

export const postData = async ( value ) => {
    const data = await axios.post(`/api/trips` , value);
    return data;
}
export const getReservedList = async () => {
    const data = await axios.get(`/api/trips/reserved_by_driver`);
    return data;
}
export const getNotReserved = async () => {
    const data = await axios.get(`/api/trips/not_reserved_for_driver`);
    return data;
}
export const getTrip = async () => {
    const data = await axios.get(`/api/trips/not_reserved_for_driver` );
    return data;
}
export const postAccept = async (value1 , value2) => {
    const data = await axios.get(`/api/trips/reserve/${value1}` );
    return data;
}
export const postReached = async (value) => {
    const data = await axios.get(`/api/trips/reached/${value}` );
    return data;
}
export const getTripList = async () => {
    const data = await axios.get(`http://goharbaar.ir/api/trips` );
    return data;
}
export const getInfo = async () => {
    const data = await axios.post(`/api/user-info` );
    return data;
}
export const logout = async () => {
    const data = await axios.post(`/api/logout` );
    return data;
}
export const postCancel = async (value) => {
    const data = await axios.post(`/api/courier/cancel-trip/${value}` );
    return data;
}